import { ToastContainer, toast } from "react-toastify";
import Collapsible from "../../components/Collapsible/Collapsible";
import "react-toastify/dist/ReactToastify.css";

const getIcon = (type) => {
  let bg = "";
  let icon = "";

  switch (type) {
    case "success":
      bg = "success";
      icon = "check";
      break;
    case "warning":
    case "danger":
      bg = "danger";
      icon = "exclamation";
      break;
    default:
      bg = "primary";
      icon = "check";
      break;
  }

  return (
    <div
      className={`d-flex bg-${bg} notification-card align-items-center justify-content-center`}
    >
      <i className={`far fa-${icon}-circle`}></i>
    </div>
  );
};

const Notify = {
  static: (msg, options = {}) => {
    let toastId = "static";
    let toastIsActive = toast.isActive(toastId);

    let toastContent = (
      <div className="d-flex notification-container">
        {getIcon("danger")}
        <div className="d-flex align-items-center justify-content-center notification-message">
          <span>{msg}</span>
        </div>
      </div>
    );

    let toastOptions = {
      toastId: "static",
      position: options["position"] ? options["position"] : "bottom-left",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      ...options,
    };

    //Check if a toast is displayed or not
    if (toastIsActive) {
      toastOptions.render = toastContent;
      toast.update(toastId, toastOptions);
    } else {
      toast(toastContent, toastOptions);
    }
  },
  success: (msg, options = {}) => {
    let toastId = "success";
    let toastIsActive = toast.isActive(toastId);
    let toastContent = (
      <div className="d-flex notification-container">
        {getIcon(toastId)}
        <div className="d-flex align-items-center justify-content-center notification-message">
          <span>{msg}</span>
        </div>
      </div>
    );

    let toastOptions = {
      toastId: toastId,
      className: toastId,
      position: options["position"] ? options["position"] : "bottom-left",
      ...options,
    };

    if (toastIsActive) {
      toastOptions.render = toastContent;
      toast.update(toastId, toastOptions);
    } else {
      toast(toastContent, toastOptions);
    }
  },
  error: (msg, options = {}) => {
    let toastId = "error";
    let toastIsActive = toast.isActive(toastId);

    let toastContent = (
      <div className="d-flex notification-container">
        {getIcon("danger")}
        <div className="d-flex align-items-center justify-content-center notification-message">
          <span>{msg}</span>
        </div>
      </div>
    );

    let toastOptions = {
      toastId: toastId,
      className: toastId,
      position: options["position"] ? options["position"] : "bottom-left",
      ...options,
    };

    if (toastIsActive) {
      toastOptions.render = toastContent;
      toast.update(toastId, toastOptions);
    } else {
      toast(toastContent, toastOptions);
    }
  },
  errors: (title, errors = [], options = {}, lang = "en") => {
    let toastId = "errors";
    let toastIsActive = toast.isActive(toastId);
    let label = lang == "en" ? "Show more" : "Mostrar mas";
    let openedLabel = lang == "en" ? "Show less" : "Mostrar menos";

    let toastContent = (
      <div className="d-flex notification-container">
        {getIcon("danger")}
        <div className="d-flex notification-message flex-column">
          <div>{title}</div>
          <Collapsible
            showAngle
            top
            label={label}
            openedLabel={openedLabel}
            isOpen={errors.length == 1}
          >
            <ul className="me-auto">
              {errors.map((error, index) => {
                return <li key={index}>{error}</li>;
              })}
            </ul>
          </Collapsible>
        </div>
      </div>
    );

    let toastOptions = {
      toastId: toastId,
      className: "error",
      position: options["position"] ? options["position"] : "bottom-left",
      autoClose: options["autoClose"] ? options["autoClose"] : 15000,
      closeOnClick: false,
      draggable: false,
      ...options,
    };

    if (toastIsActive) {
      toastOptions.render = toastContent;
      toast.update(toastId, toastOptions);
    } else {
      toast(toastContent, toastOptions);
    }
  },
};

const Notification = ({ ...rest }) => {
  return (
    <div className="notification-component">
      <ToastContainer {...rest} />
    </div>
  );
};

Notification.static = Notify.static;
Notification.success = Notify.success;
Notification.error = Notify.error;
Notification.errors = Notify.errors;
Notification.toast = toast;

export default Notification;
